import Clipboard from 'clipboard'
import { Toast } from 'vant'

function clipboardSuccess() {
  Toast('Copied successfully')
}

function clipboardError() {
  Toast('Copy failed')
}

export default function handleClipboard(text, event) {
  const clipboard = new Clipboard(event.target, {
    text: () => text
  })
  clipboard.on('success', () => {
    // clipboardSuccess()
    clipboard.destroy()
  })
  clipboard.on('error', () => {
    // clipboardError()
    clipboard.destroy()
  })
  clipboard.onClick(event)
}
